import { getCookie } from "@/lib/cookies";
import { getShortLngFromCulture } from "@/utils/get-short-lng";

/** Current UI language short code from the shop-culture cookie. */
export function useLng(): string {
  return getShortLngFromCulture(getCookie("shop-culture"));
}
